export default {
    GET_LIST_CATEGORY: 'GET_LIST_CATEGORY',
    ADD_NEW_CATEGORY: 'ADD_NEW_CATEGORY',
    DELETE_CATEGORY: 'DELETE_CATEGORY',
    DELETE_LIST_CATEGORIES: 'DELETE_LIST_CATEGORIES',
    UPDATE_CATEGORY: 'UPDATE_CATEGORY',
    CHANGE_ACTIVATION: 'CHANGE_ACTIVATION',
    ADD_IMAGE_CATEGORY: 'ADD_IMAGE_CATEGORY'
};